import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useDispatch } from 'react-redux'

import OrdeDetails from 'components/OrderDetails'

import { fetchOrder } from 'utils/api'

const OrderDetails = () => {
  const [order, setOrder] = useState({})

  const dispatch = useDispatch()
  const { uuid } = useParams()

  useEffect(() => {
    let isMounted = true
    fetchOrder(uuid)?.then((res) => {
      if (isMounted) setOrder(res?.data)
    })

    return () => {
      isMounted = false
    }
  }, [uuid, dispatch])

  return <OrdeDetails order={order} />
}

export default OrderDetails
